import { Role } from '@type/common'

// Minimal shape needed to decide admin status from a /me payload. Both the
// full Account (the React admin hook) and the narrowed NavFilterUser
// (filterNavItems) satisfy this structurally.
export type AdminCheckUser = {
  role?: Role | string | null
  roles?: { is_system: boolean; name: string }[] | null
  role_info?: { is_system: boolean; name: string } | null
}

/**
 * Pure admin check shared by the React admin hook and filterNavItems'
 * non-render path. Single source of truth so the two cannot drift during
 * the RBAC migration. Resolution order:
 *   1. multi-role assignments — match any built-in Admin role
 *   2. denormalized single-FK pointer (role_info)
 *   3. legacy role string emitted by /me for pre-RBAC users
 */
export const isAdminUser = (user?: AdminCheckUser | null): boolean => {
  if (!user) return false
  if (user.roles && user.roles.length > 0) {
    return user.roles.some((r) => r.is_system && r.name === 'Admin')
  }
  if (user.role_info) {
    return user.role_info.is_system && user.role_info.name === 'Admin'
  }
  return user.role === Role.admin
}
